import { Link } from "react-router-dom";
import { linksMenu, navSections, siteInfo } from "@/mocks/home";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          <div>
            <h3 className="font-heading text-2xl text-background-50">{siteInfo.name}</h3>
            <p className="mt-3 text-sm text-background-200/90 max-w-xs">
              {siteInfo.tagline}. Cultivating knowledge and love of gardening since 1949.
            </p>
            <a
              href="#home"
              className="mt-6 inline-flex items-center gap-2 text-sm text-accent-300 hover:text-accent-200 transition-colors"
            >
              <i className="ri-arrow-up-line" aria-hidden="true" />
              Back to top
            </a>
          </div>

          <div>
            <h4 className="text-[11px] uppercase tracking-[0.28em] text-secondary-300">Explore</h4>
            <ul className="mt-4 space-y-2.5">
              {navSections.map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`} className="text-sm text-background-200/90 hover:text-background-50 transition-colors">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] uppercase tracking-[0.28em] text-secondary-300">More</h4>
            <ul className="mt-4 space-y-2.5">
              {linksMenu.map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-sm text-background-200/90 hover:text-background-50 transition-colors">
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/members"
                  className="inline-flex items-center gap-2 text-sm text-background-200/90 hover:text-background-50 transition-colors cursor-pointer"
                >
                  Members Sign In
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-700/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-200/70">
            © {year} {siteInfo.copyright}. All rights reserved.
          </p>
          <p className="text-xs text-background-200/70">
            A member of The Garden Club of America
          </p>
        </div>
      </div>
    </footer>
  );
}